import Swal from 'sweetalert2'

const DEFAULT_ALERT_OPTS = {
  title: 'Are you sure?',
  text: 'Once deleted, you will not be able to recover this!',
  icon: 'warning',
  showCancelButton: true,
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  confirmButtonText: 'Yes'
}

// eslint-disable-next-line import/prefer-default-export
export const confirmAlert = (opts = {}) => Swal.fire({ ...DEFAULT_ALERT_OPTS, ...opts })
  .then((result) => result.isConfirmed)
